import { useEffect, useMemo, useState } from 'react';
import RegionalService from '../services/RegionalService';
import regionalApiService from '../services/RegionalApiService';

const getContextRegionalId = (context) => (
  context?.idRegional ||
  context?.IdRegional ||
  context?.regionalId ||
  context?.RegionalId ||
  null
);

const getCurrentRegionalId = (user) => (
  RegionalService.getActiveRegionalId() ||
  getContextRegionalId(user?.currentAccessContext) ||
  getContextRegionalId(user?.contextoAccesoActual) ||
  user?.regionalId ||
  user?.RegionalId ||
  user?.idRegional ||
  user?.IdRegional ||
  null
);

const extractFeatureFlags = (response) => {
  const flags = response?.featureFlags || response?.FeatureFlags || response?.ffRegional || response?.FFRegional || [];
  return Array.isArray(flags) ? flags : [];
};

const useRegionalFeatureFlags = (user, { enabled = true } = {}) => {
  const activeRegionalId = useMemo(() => getCurrentRegionalId(user), [user]);
  const [featureFlags, setFeatureFlags] = useState(() => RegionalService.getFeatureFlags());
  const [isRefreshingFeatureFlags, setIsRefreshingFeatureFlags] = useState(false);

  useEffect(() => {
    if (!enabled) {
      setIsRefreshingFeatureFlags(false);
      return;
    }

    if (!activeRegionalId) {
      setFeatureFlags(RegionalService.getFeatureFlags());
      setIsRefreshingFeatureFlags(false);
      return;
    }

    let cancelled = false;
    setIsRefreshingFeatureFlags(true);
    setFeatureFlags(RegionalService.getFeatureFlags());

    regionalApiService.getFeatureFlagsByRegional(activeRegionalId)
      .then((response) => {
        if (cancelled) return;
        const flags = extractFeatureFlags(response);
        RegionalService.setFeatureFlags(flags);
        setFeatureFlags(flags);
      })
      .catch((error) => {
        console.warn('No se pudieron refrescar las feature flags de la regional activa:', error);
        if (cancelled) return;
        setFeatureFlags(RegionalService.getFeatureFlags());
      })
      .finally(() => {
        if (!cancelled) {
          setIsRefreshingFeatureFlags(false);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [activeRegionalId, enabled]);

  return {
    activeRegionalId,
    featureFlags,
    isRefreshingFeatureFlags
  };
};

export default useRegionalFeatureFlags;
